import { Component, Renderer2 } from "@angular/core";
import * as FileSaver from "file-saver";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { ReportsService } from "../../../../core/services/reports.service";
import { CommonModule } from "@angular/common";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { OrdersWrittenReportDetailResponse } from "../../../../core/models/reports/ordersWrittenReportDetailResponse";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { GenericFilterRequestDto } from "../../../../core/models/shared/genericFilterRequestDto";
import { GenericRequestDto } from "../../../../core/models/shared/genericRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { SharedService } from "../../../../core/services/shared.service";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { FilterMetadata } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { VendorSummaryComponent } from "../../../vendors/components/vendor-summary/vendor-summary.component";

@Component({
  selector: "jni-order-written-report-paginated",
  templateUrl: "./order-written-report-paginated.component.html",
  styleUrls: ["./order-written-report-paginated.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    HidedynamicsdatePipe,
    DateFilterComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    VendorSummaryComponent,
  ],
})
export class OrderWrittenReportPaginatedComponent {
  orderDisplayModal = false;
  clientDisplayModal = false;
  vendorDisplayModal = false;
  clientId = "";
  saleOrderId = "";
  vendorAccountNumber = "";

  ordersWrittenReportDetailLists: OrdersWrittenReportDetailResponse[] = [];
  filterOrdersWrittenReportDetailLists: OrdersWrittenReportDetailResponse[] =
    [];

  defaultTake = 20;
  currentPagination = 20;
  totalRecords = 0;
  lazyLoadEvent: TableLazyLoadEvent = {};
  filterDebounceTime = 1000;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  filterTextChanged: Subject<any> = new Subject<any>();
  /* eslint-enable @typescript-eslint/no-explicit-any */
  inHandDateFieldName = "inHandDate";
  createdDateFieldName = "createdDate";
  createdDateFilter = {} as DateFilter;
  inHandDateFilter = {} as DateFilter;
  filterMode = "server";

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private renderer: Renderer2,
    private _sharedService: SharedService
  ) {}

  getOrdersWrittenReportDetail(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    this._loaderService.setLoaderState(true);
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const filterData = event?.filters?.[x] as FilterMetadata;
      return {
        columnName: x ?? "",
        matchMode: filterData?.matchMode ?? "",
        tableName: "",
        value: filterData?.value ?? "",
      } as GenericFilterRequestDto;
    });

    filter.forEach(x => {
      if (x.columnName == "buyer") {
        x.columnName = "BuyerD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "clientPO") {
        x.columnName = "CustomerPONumberD365";
        x.tableName = "SalesOrderHeader";
      }

      let createdDate = "";
      if (this.createdDateFilter.startDate) {
        createdDate =
          this._sharedService.convertDateFormat(
            this.createdDateFilter.startDate ?? ""
          ) +
          "|" +
          this._sharedService.convertDateFormat(
            this.createdDateFilter.endDate ?? ""
          );
      }

      if (x.columnName == "createdDate") {
        x.columnName = "CreatedDate";
        x.tableName = "SalesOrderHeader";
        x.value = createdDate;
        x.matchMode = this.createdDateFilter.selectedMatchMode ?? "";
      }
      if (x.columnName == "customerName") {
        x.columnName = "KnownAsD365";
        x.tableName = "Client";
      }
      // if (x.columnName == 'ihd') {
      //   (x.columnName = 'InHandsDateD365'), (x.tableName = 'SalesOrderHeader');
      // }
      if (x.columnName == "jobName") {
        x.columnName = "JobNameD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "salesOrder") {
        x.columnName = "SalesOrderIdD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "status") {
        x.columnName = "SalesOrderStatusD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "accountCoordinator") {
        x.columnName = "FirstName,LastName";
        x.tableName = "accountCoordinator";
      }
      if (x.columnName == "brandingConsultant") {
        x.columnName = "FirstName,LastName";
        x.tableName = "brandingConsultant";
      }

      let inHandDate = "";
      if (this.inHandDateFilter.startDate) {
        inHandDate =
          this._sharedService.convertDateFormat(
            this.inHandDateFilter.startDate ?? ""
          ) +
          "|" +
          this._sharedService.convertDateFormat(
            this.inHandDateFilter.endDate ?? ""
          );
      }

      if (x.columnName == "inHandDate") {
        x.columnName = "InHandsDateD365";
        x.tableName = "SalesOrderHeader";
        x.value = inHandDate;
        x.matchMode = this.inHandDateFilter.selectedMatchMode ?? "";
      }
    });

    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
    };
    this._reportsService
      .getOrdersWrittenReportDetailPaginated(request)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.totalRecords = res.totalRecords ?? 0;
          if (res.data) {
            this.ordersWrittenReportDetailLists = res.data;
            this.filterOrdersWrittenReportDetailLists =
              this.ordersWrittenReportDetailLists;
          } else {
            this._toastr.error(res.message, "Error");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(res.message, "Error");
        },
      });
  }

  // onInHandDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.ordersWrittenReportDetailLists.filter((x) =>
  //       x.ihd?.includes(event.target.value)
  //     );
  //     this.filterOrdersWrittenReportDetailLists = filterList;
  //   } else {
  //     this.filterOrdersWrittenReportDetailLists =
  //       this.ordersWrittenReportDetailLists;
  //   }
  // }

  // onCreatedDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.ordersWrittenReportDetailLists.filter((x) =>
  //       x.createdDate?.includes(event.target.value)
  //     );
  //     this.filterOrdersWrittenReportDetailLists = filterList;
  //   } else {
  //     this.filterOrdersWrittenReportDetailLists =
  //       this.ordersWrittenReportDetailLists;
  //   }
  // }

  redirectToClient(client: string) {
    //const url = `/clients/active/client-details/${client}`;
    //this.route.navigate([url]);
    if (client) {
      this.clientId = client;
      this.clientDisplayModal = true;
    }
  }

  redirectToVendor(vendor: string) {
    // const url = `/vendors/vendor-summary/${vendor}`;
    //this.route.navigate([url]);
    if (vendor) {
      this.vendorAccountNumber = vendor;
      this.vendorDisplayModal = true;
    }
  }

  redirectToSaleorder(saleorder: string) {
    //const url = `/orders/order-summary/${saleorder}`;
    //this.route.navigate([url]);
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.ordersWrittenReportDetailLists);
  }

  exportExcelForFilterData(
    filterclientlist: OrdersWrittenReportDetailResponse[]
  ) {
    const object = filterclientlist.map(datum => {
      return {
        ["Sale Order"]: datum.salesOrder,
        ["Created Date"]: new Date(datum.createdDate),
        ["Client Name"]: datum.customerName,
        ["Job Name"]: datum.jobName,
        ["IHD"]: new Date(datum.ihd ?? ""),
        ["Branding Consultant"]: datum.brandingConsultant,
        ["Account Coordinator"]: datum.accountCoordinator,
        ["Status"]: datum.status,
        ["Highest Net Vendor"]: datum.highestNetVendor,
        ["Currency"]: datum.currency,
        ["Order Total"]: datum.orderSubTotal,
        ["Commission"]: datum.commission,
        ["Net GP%"]: datum.orderNetGP,
        ["Buyer"]: datum.buyer,
        ["Client PO"]: datum.clientPO,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrdersWrittenReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onFilterInputDate(
    $event: OrdersWrittenReportDetailResponse[] | DateFilter,
    value = ""
  ) {
    if (!Array.isArray($event) && value === "clear") {
      this.clearFilter($event);
    }

    if (!Array.isArray($event) && $event?.startDate) {
      this.applyDateFilter($event);
    }

    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getOrdersWrittenReportDetail(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next({ $event });
  }

  onFilterInput($event: Event) {
    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getOrdersWrittenReportDetail(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next({ $event });
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  clearFilter(event: DateFilter) {
    if (event.columnName === this.createdDateFieldName) {
      this.createdDateFilter = {} as DateFilter;
    } else if (event.columnName === this.inHandDateFieldName) {
      this.inHandDateFilter = {} as DateFilter;
    }
  }

  applyDateFilter(event: DateFilter) {
    if (event.startDate && event.columnName === this.createdDateFieldName) {
      this.createdDateFilter = event;
    } else if (
      event.startDate &&
      event.columnName === this.inHandDateFieldName
    ) {
      this.inHandDateFilter = event;
    }
  }
}
